module.exports = __webpack_public_path__ + "static/media/logo.13637c51.svg";